import InlineTable from './inline-table';
import inlineClickEvent from './inline-table-click-event';

/**
 * Gets all inline table links, iterates over them and adds an event listener to allow for that
 * will toggle an inline table for a given link and table.
 */
export default function() {
  const inlineTableItemLinks = document.querySelectorAll('[data-role="inline-table-item-link"]');
  const inlineTableGroup = document.querySelector('[data-role="inline-table-group"]');

  // @TODO: Replace with custom foreach function.
  for (let i = 0; i < inlineTableItemLinks.length; ++i) {
    const inlineTable = new InlineTable(inlineTableItemLinks[i].getAttribute('href'));

    inlineTableItemLinks[i].addEventListener(
      'click',
      inlineClickEvent.bind(inlineTableItemLinks[i], inlineTableGroup, inlineTable)
    );
  }
}
